import React, { useState } from "react"
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "../styles/styles.css";
import "../styles/styles.scss";
import 'react-calendar/dist/Calendar.css';
import Admin from '../layouts/Admin';
import Main from '../layouts/Main';
import ManageMatchResult from '../layouts/ManageMatchResult';
import ManageApplication from '../layouts/ManageApplication';
import { AuthContext } from "../utilities/auth";
import PrivateRoute from '../components/PrivateRoute';
import TeamRosters from '../layouts/TeamRosters';
import BlackList from '../layouts/BlackList'
import ApplicationsManagment from '../layouts/ApplicationsManagment';
import LeaguesManagement from '../layouts/LeaguesManagement';
import ManageLeague from '../layouts/ManageLeague';
import PartnersManagement from '../layouts/PartnersManagement';
import TeamsManagement from '../layouts/TeamsManagement';
import ManageTeam from '../layouts/ManageTeam';
import PlayersManagement from '../layouts/PlayersManagement';
import PlayerDetail from '../layouts/PlayerDetail';
import StagesManagement from '../layouts/StagesManagement';
import LeagueChampionsManagement from '../layouts/LeagueChampionsManagement';
import LeagueTourTeamManagement from '../layouts/LeagueTourTeamManagement';
import ManageMatchMedia from '../layouts/ManageMatchMedia';
import SelectMatchMedia from '../layouts/SelectMatchMedia';
import LeagueDisqualificationsManagement from '../layouts/LeagueDisqualificationsManagement';
import ScheduleManagement from '../layouts/ScheduleManagement';
import InfographicsCatalog from '../layouts/InfographicsCatalog';
import InfographicsEditor from '../layouts/InfographicsEditor';
import InfographicsBatch from '../layouts/InfographicsBatch';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

function App(props) {
  const existingTokens = JSON.parse(localStorage.getItem("userData"));
  const [userData, setUserData] = useState(existingTokens);

  const setData = (data) => {
    localStorage.setItem("userData", JSON.stringify(data ?data :false));
    setUserData(data);
  }

  return (
    <AuthContext.Provider value={{ userData, setUserData: setData }}>
      <Router>
        <Switch>
          <Route exact path="/" component={Main} />
          <PrivateRoute path="/admin" component={Admin} />
          <PrivateRoute path="/applications_managment" component={ApplicationsManagment} />
          <PrivateRoute path="/black_list" component={BlackList} />
          <PrivateRoute path="/leagues_management" exact roles={[6]} component={LeaguesManagement} />
          <PrivateRoute path="/leagues_management/:leagueId" roles={[6]} component={ManageLeague} />
          <PrivateRoute path="/partners_management" roles={[6]} component={PartnersManagement} />
          <PrivateRoute path="/stages_management" component={StagesManagement} />
          <PrivateRoute path="/league_champions" component={LeagueChampionsManagement} />
          <PrivateRoute path="/league_tour_team" component={LeagueTourTeamManagement} />
          <PrivateRoute path="/league_disqualifications" component={LeagueDisqualificationsManagement} />
          <PrivateRoute path="/teams_management" exact component={TeamsManagement} />
          <PrivateRoute path="/teams_management/:teamId" component={ManageTeam} />
          <PrivateRoute path="/players_management" exact component={PlayersManagement} />
          <PrivateRoute path="/player/:playerId" component={PlayerDetail} />
          <PrivateRoute path="/schedule_management" component={ScheduleManagement} />
          <PrivateRoute path="/infographics" exact component={InfographicsCatalog} />
          <PrivateRoute path="/infographics/batch" exact component={InfographicsBatch} />
          <PrivateRoute path="/infographics/:patternId" component={InfographicsEditor} />
          <PrivateRoute path="/manage_match/:id" component={ManageMatchResult} />
          <PrivateRoute path="/select_match_media" component={SelectMatchMedia} />
          <PrivateRoute path="/manage_match_media/:matchId" component={ManageMatchMedia} />
          <PrivateRoute path="/manage_application/:id" component={ManageApplication} />
          <PrivateRoute path="/team_rosters/:id/:application_id" component={TeamRosters} />
          </Switch>
      </Router>
    </AuthContext.Provider>
  );
}

export default App;